import React from 'react';

import FrameFilters from '../../../../id8/components/frames/filters/FrameFilters';
import FrameOutput from '../../../../id8/components/frames/output/FrameOutput';
import ImagesGeneratingConsumerStatusController from '../generating-status-controller/ImagesGeneratingConsumerStatusController';
import { PROMPT_TYPE } from '../../../../constants';

import scss from '../../Id8.module.scss';

function FramesTab() {
  return (
    <div className={scss.outputWrapper}>
      <FrameFilters />
      <FrameOutput />

      <ImagesGeneratingConsumerStatusController
        promptType={PROMPT_TYPE.IDEA}
        generationLabel='imagesGenerationInProgress'
      />
    </div>
  );
}

export default FramesTab;
